export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f32f8e0a770c10a6ba3c5a5a45ad49b9917462664&name=fetchTypeahead!'